import React, { useContext, useEffect, useState } from "react";
import TkButton from "../../atoms/TkButton";
import { TkButtonProps } from "../../../type/componentsType/TkButton";
import { useNavigate } from "react-router-dom";
import { TkRouteContext } from "../../../context/tkRouteContext";
import { GlobalContext } from "../../../context/globalContext";
import authorityUserType from "../../../assets/data/TkAuthorityProperty";
import { BusinessContext } from "../../../context/businessContext";

/**
 * 戻るボタン部品
 * 遷移元画面に戻るボタン
 * @return TkBackButton 戻るボタン部品
 */
export const TkBackButton: React.FC<TkButtonProps> = (props) => {
  const { useBackParam, navigateParam, ...rest } = props;

  const navigate = useNavigate();
  const { state, setState } = useContext(TkRouteContext);
  const { state: globalState, setState: setGlobalState } =
    useContext(GlobalContext);
  const { setState: setBusinessState } = useContext(BusinessContext);

  // パンくずリストが空の場合、非表示
  const [useBack, setUseBack] = useState(true);

  useEffect(() => {
    const routerList = state?.routerList || [];

    if (routerList.length <= 1) {
      setUseBack(false);
    } else {
      setUseBack(true);
    }
  }, [state?.routerList]);

  const handleClick = () => {
    let routerList = state.routerList || [];

    if (routerList.length > 1) {
      setState({
        ...state,
        routerList: [...routerList.slice(0, routerList.length - 1)],
      });
      setGlobalState({ ...globalState, errorMsgId: "" });
      navigate(
        `${routerList[routerList.length - 2].href}`,
        useBackParam
          ? {
              state: {
                backButtonFlag: useBackParam,
                ...navigateParam,
              },
            }
          : {}
      );
    } else if (
      globalState.authInfo?.userType === authorityUserType.userTypeNumber.KIKO
    ) {
      setBusinessState({});
      setGlobalState({ ...globalState, errorMsgId: "" });
      navigate("/SCRW110001");
    } else {
      setState({
        ...state,
        routerList: [...[]],
      });
      navigate("/error");
    }
  };

  return useBack ? (
    <TkButton {...rest} onClick={handleClick} data-testid="TkBackBtn">
      戻る
    </TkButton>
  ) : (
    <></>
  );
};

export default TkBackButton;
